export const storeProducts = [
  {
    id: 1,
    title: "Akai MPC Studio",
    img: "img/product-1.png",
    price: 399.99,
    company: "Akai",
    info:
      "The black MPC Studio from Akai Professional fuses the legendary MPC layout and workflow with the power of a Mac or Windows computer. The system is a fully integrated hardware/software system using the classic MPC hardware controls coupled with the MPC Software that provides expandable production capabilities. The system offers a streamlined experience with its under one-inch thick controller, that features low-profile controls and a brushed aluminum body, perfect for a portable laptop system. The software provides 128-track sequencing and a 7GB+ sound library, including all of the sounds of the classic MPC3000 + 2 MPC expansions and support for multiple sound formats.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "Ableton Push 2",
    img: "img/product-2.png",
    price: 799.00,
    company: "Ableton",
    info:
      "Ableton Push 2 is an instrument that puts everything you need to make music in one place—at your fingertips.  Making music is hard. To stay in the flow, you need to be able to capture your ideas quickly, and you need technology to stay out of the way. Computers make it possible for one person to create whole worlds of sound. But instruments are where inspiration comes from. Push gives you the best of everything. It’s a powerful, expressive instrument that gives you hands-on control of an unlimited palette of sounds, without needing to look at a computer.  Push 2 works with Ableton Live 9.5. Live runs on your Mac or PC and provides multitrack recording, instruments, effects, and everything else you need to make music.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "Maschine MK3",
    img: "img/product-3.png",
    price: 649.00,
    company: "Native Instruments",
    info:
      "The third-generation Native Instruments Maschine Groove Production Studio offers dramatic improvements over its predecessor, giving experienced and novice users alike a colorful, revamped set of tactile controls -- along with loads of included samples, FX, and a full version of NI's Massive synth -- that will take live performances to the next level. Upgraded to speed up and improve your workflow, Maschine is a hardware/software beast of an instrument that covers all the bases for computer-based music production. It's essentially a professional sampler, a high-resolution 96kHz/24-bit audio interface, a pattern-based sequencer, a multi-effects unit, and a VST/AU plug-in host all in one sleek box, with streamlined buttons and knobs for composing, performing, sampling, slicing, and tweaking effects on the fly. Since you can use it to control your DAW as well as all your hardware sound modules and sequencers, Maschine MK3 will quickly become the center of your rig.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Akai Professional Force",
    img: "img/product-4.png",
    price: 999.00,
    company: "Akai",
    info:
      "Akai Professional, a leading manufacturer of music equipment for performers and producers, announced the release of its standalone Force music production/ DJ performance device, with clip launching, step sequencing, sampling, synths and a 7-inch multi-touch display. Force is designed for the user who wants a standalone product with the latest in modern workflow techniques, free from being connected to the computer. Force is the first standalone music production device that truly captures the modern clip-based workflow.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: " Novation Launchkey Mini",
    img: "img/product-5.png",
    price: 109.99,
    company: "Novation",
    info:
      "Launchkey Mini is Novation's most compact and portable 25-mini-key MIDI keyboard controller. It gives you everything you need to start creating in Ableton Live – and it’ll fit in your bag. Make tracks anywhere with Launchkey Mini’s deep, intuitive Ableton control, arpeggiator, fixed chord mode, MIDI out, and tons of sounds in the box.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "M-Audio Oxygen 25",
    img: "img/product-6.png",
    price: 134.87,
    company: "M-Audio",
    info:
      "With an array of assignable knobs, pads, and a fader, Oxygen 25 gives you total control over your software, allowing you to stay engaged in the creative flow of recording and mixing music without ever reaching for the mouse. It features 25 velocity-sensitive keys for playing chords, bass lines, and melodies; eight assignable knobs for tweaking effect plugins and virtual instruments; eight velocity-sensitive pads for triggering samples or finger drumming; and an assignable fader that is ideal for controlling the master output or mixing tracks together. Oxygen 25 also has dedicated transport controls and track-up and -down buttons that allow you to initiate play, stop, and record in the DAW environment right from your keyboard controller.",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "Akai MPK Mini mkII ",
    img: "img/product-7.png",
    price: 119.00,
    company: "Akai",
    info:
      "Perform, produce, jam and learn anywhere your creativity takes you with the new MPK Mini Play.  The ultra-portable MPK Mini Play is based on the world’s most popular midi controller—Akai Professional’s MPK Mini—but now it comes packed with 128 sounds and its own built-in speaker. Add in 8 backlit MPC drum pads, knobs for editing your sounds and a 4-way joystick for simple control, and you have all you need to take your music on-the-go.  Powered by 3 “AA” batteries, the MPK Mini Play is built for hours of wireless fun. You can also connect to a computer via USB port for plug-and-play MIDI capability. Don’t want to disturb others or you want really big sound? Use the mini-audio output jack to connect headphones or any external speakers you want.  All-in-one, easy-to-use fun with “pro” features—that’s the MPK Mini Play!",
    inCart: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Nektar Impact LX25+",
    img: "img/product-8.png",
    price: 129.97,
    company: "Nektar",
    info:
      "The Impact LX25+ is a compact and portable MIDI controller with intelligent and expressive performance control. Built into the Nektar Impact LX25+ is a DAW Integration unprecedented in controllers of its class. It is custom designed for Bitwig, Cubase, Digital Performer, FL Studio, GarageBand, Logic, Nuendo, Reaper, Reason, Sonar and Studio One, taking the Impact LX25+ beyond functionality normally offered by a USB MIDI controller keyboard. With Impact LX25+ the hard work is done, so you can focus on your creativity. A copy of Bitwig 8-Track is included with your order.",
    inCart: false,
    count: 0,
    total: 0
  }
];

export const detailProduct = {
  id: 1,
  title: "Akai MPC Studio",
  img: "img/product-1.png",
  price: 399.99,
  company: "Akai",
  info:
    "The black MPC Studio from Akai Professional fuses the legendary MPC layout and workflow with the power of a Mac or Windows computer. The system is a fully integrated hardware/software system using the classic MPC hardware controls coupled with the MPC Software that provides expandable production capabilities. The system offers a streamlined experience with its under one-inch thick controller, that features low-profile controls and a brushed aluminum body, perfect for a portable laptop system. The software provides 128-track sequencing and a 7GB+ sound library, including all of the sounds of the classic MPC3000 + 2 MPC expansions and support for multiple sound formats.",
  inCart: false,
  count: 0,
  total: 0
};
